import styled from 'styled-components';

/**
* @module HubspotForm
* @description A styled React component that provides the container for the 
* HubSpot V4 developer embed form. The form div is injected and managed by
* GetQuote.js — this component simply provides the styled mount point.
*/
const HubspotForm = () => {
  return (
    <HubspotForm.Wrapper id="hs-form-container" />
  );
};

HubspotForm.Wrapper = styled.div`
  width: 100%;
  font-family: "Gotham-book" !important;
  font-size: 16px;
  margin-top: 16px;

  .hsfc-Step__Content {
    padding: 0px !important;
    font-family: 'Gotham-book' !important;
  }

  .hsfc-Row {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 6px;
  }

  .hsfc-TextField,
  .hsfc-EmailField,
  .hsfc-PhoneField,
  .hsfc-DropdownField {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    width: 100%;
  }

  .hsfc-FieldLabel {
    flex: 0 1 26%;
    font-weight: bold;
    font-size: 16px;
  }

  .hsfc-FieldLabel strong {
    font-family: "Gotham-book" !important;
    font-weight: normal !important;
    font-size: 16px !important;
  }

  .hsfc-FieldLabel__RequiredIndicator {
    color: var(--app-red);
    margin-left: 2px;
  }

  .hsfc-ErrorAlert {
    display: block;
    width: 70%;
    color: var(--app-red);
    font-size: 14px;
    margin-top: 4px;
    margin-left: 26%;
  }

  .hsfc-TextInput {
    flex: auto;
    width: auto !important;
    height: 2.5rem;
    outline: none;
    background: var(--app-light-gray);
    border: none;
    border-radius: 0px;
    padding: 0 8px;
    font-size: 16px;
  }

  .hsfc-TextInput:focus,
  .hsfc-TextInput:hover {
    outline: none !important;
    border: none !important;
    box-shadow: none;
  }

  .hsfc-DropdownInput {
    flex: auto;
    position: relative;
  }

  .hsfc-TextInput--button {
    background-color: var(--app-light-gray);
    cursor: pointer;
  }

  /* Hide native HubSpot submit button — we use our own */
  .hsfc-Button,
  .hsfc-NavigationRow {
    display: none !important;
  }

  /* Hide phone flag/caret */
  .hsfc-PhoneInput__FlagAndCaret {
    display: none;
  }

  /* Hide post-submit thank you screen */
  .hsfc-PostSubmit {
    display: none !important;
  }
`;

export default HubspotForm;